import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCall, MdEmail, MdLocationPin, MdSearch, MdWhatsapp } from "react-icons/md";
import { AiFillWechat } from "react-icons/ai";

export default function ContactUsContent(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection bg-secondary"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px"
				}}
			>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<div
								className="main-section-title text-primary"
							>
								We’re here to help. Reach out with any inquiries, feedback, or project requests, and our team will respond promptly.
							</div>
						</div>

						

						<div className="col-md-12">
							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									
									window.open('mailto:info@fimacy.co.tz', '_blank')
									
								}}
								className="font-bold text-light"
							>
								<MdEmail
									className="text-extra"
								size={32}/>  info@fimacy.co.tz
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									window.open('tel:+255769425903', '_blank')
								}}
								className="font-bold text-light"
							>
								<MdCall
									className="text-extra"
								size={32}/>  
								+255 769 425 903 | +255 719 363 754

							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									window.open("https://wa.me/+255769425903", "_blank");
							
								}}
								className="font-bold text-light"
							>
								<MdWhatsapp
									className="text-extra"
								size={32}/> Click to chat with us on WhatsApp
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									window.open("https://wa.me/+255754300767", "_blank");
							
								}}
								className="font-bold text-light"
							>
								<MdLocationPin
									className="text-extra"
								size={32}/>  
								New Bagamoyo Road, green Acres House Victoria, plot No 73 - Block 45b
							</h6>

							
							
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}